import { Fragment } from 'react';
import classNames from 'classnames';

import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from '../../../default-props/noop';
import { DropdownMenu } from '../../dropdown-menu';
import { DropdownMenuToggler } from '../../dropdown-menu-toggler';
import { Button } from '../index';

import type { MultiActionButtonType } from './multi-action-button.types';

export const MultiActionButton: MultiActionButtonType = ({
  children,
  onClick = noop,
  otherActions = emptyArray,
  disabled = false,
  theme = '',
  ...rest
}) => {
  const hasOtherActions = !!otherActions.length;
  const buttonClasses = classNames(style['button-styles'], {
    [style['button-with-dropdown']]: hasOtherActions,
  });

  return (
    <div className={style.wrapper}>
      <Button className={buttonClasses} disabled={disabled} onClick={onClick} theme={theme} {...rest}>
        {children}
      </Button>
      {!!otherActions.length && (
        <DropdownMenu dropdownMenuClassName={style['dropdown-menu']} menuPosition='bottom-right'>
          <DropdownMenuToggler className={classNames(style['drop-down-menu-button'])} theme={theme} />
          {otherActions.map((otherAction) => (
            <Fragment key={otherAction.key}>{otherAction.node}</Fragment>
          ))}
        </DropdownMenu>
      )}
    </div>
  );
};
